import { render, staticRenderFns } from "./TestResultApproval.vue?vue&type=template&id=11b88e4d"
import script from "./TestResultApproval.vue?vue&type=script&lang=js"
export * from "./TestResultApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports